export default "__VITE_ASSET__CgWqvTDh__"